import Container from '@ui/container/container';
import ComingSoonImage from './coming-soon-image/coming-soon-image';
import { useAppSelector } from '@/store/hooks';
import { selectPanelOpen } from '@/store/slices/layout-grid/selectors';
import Text from '@ui/text/text/text';

type TComingSoonProps = {
  label?: string;
};

export default function ComingSoon({ label }: TComingSoonProps) {
  const panelOpen = useAppSelector(selectPanelOpen);
  return (
    <Container background="transparent" padding="0 var(--main-content-horizontal-padding)">
      {label ? (
        <Text tag="h3" className="H3" height="32px" color="var(--gray-100)">
          {label}
        </Text>
      ) : null}
      <Container
        /* using minHeight instead of height/maxHeight prevents the image from overlaying over the label when shrinking the browser */
        minHeight="calc(66svh - 32px)"
        width={panelOpen ? 'calc(100svw - var(--panel-width-lhmp) * 2)' : 'calc(100svw * 2)'}
        maxWidth="100%"
        background="transparent"
        className="flex flex-column ai-center jc-center"
      >
        <ComingSoonImage />
      </Container>
    </Container>
  );
}
